"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = processIntegrations;
exports.utils = void 0;

var _state = _interopRequireDefault(require("./state"));

var _deepMergeWithArrayMerge = _interopRequireDefault(require("./deepMergeWithArrayMerge"));

var _types = require("./types");

var _jsCookie = _interopRequireDefault(require("js-cookie"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var createExpirationDate = (timeStamp, minutes) => {
  return new Date(timeStamp + minutes * 60000);
};

var getAmplitudeSessionId = () => {
  // If a session ID doesn't exist, generate timestamp (ms)
  var timeStamp = Date.now();
  var sessionId = _jsCookie.default.get(_types.COOKIE_KEYS.AMPLITUDE_SESSION_COOKIE_KEY) || "".concat(timeStamp); // Sets new cookie / update ttl

  _jsCookie.default.set(_types.COOKIE_KEYS.AMPLITUDE_SESSION_COOKIE_KEY, sessionId, {
    expires: createExpirationDate(timeStamp, 30)
  });

  return sessionId;
};

function processAmplitudeIntegration(amplitudeValue) {
  var ensuredObject = typeof amplitudeValue === 'object' ? (0, _deepMergeWithArrayMerge.default)({}, amplitudeValue) : {}; // eslint-disable-next-line camelcase

  ensuredObject.session_id = getAmplitudeSessionId();
  return ensuredObject;
}

function processGAIntegration(googleAnalyticsValue) {
  if (_state.default.get().gaClientId) {
    var ensuredObject = typeof googleAnalyticsValue === 'object' ? (0, _deepMergeWithArrayMerge.default)({}, googleAnalyticsValue) : {};
    ensuredObject.clientId = _state.default.get().gaClientId;
    return {
      newGaIntegrations: ensuredObject,
      newGaContext: {
        integrations: {
          'Google Analytics': {
            clientId: _state.default.get().gaClientId
          }
        }
      }
    };
  }

  return {
    newGaIntegrations: googleAnalyticsValue
  };
}

var utils = {
  createExpirationDate,
  getAmplitudeSessionId,
  processAmplitudeIntegration,
  processGAIntegration
};
exports.utils = utils;

function processIntegrations(integrations) {
  var newIntegrations = (0, _deepMergeWithArrayMerge.default)({}, integrations);
  var newContext = undefined;

  if (integrations.Amplitude) {
    newIntegrations.Amplitude = utils.processAmplitudeIntegration(integrations.Amplitude);
  }

  if (integrations['Google Analytics']) {
    var {
      newGaIntegrations,
      newGaContext
    } = utils.processGAIntegration(integrations['Google Analytics']);
    newIntegrations['Google Analytics'] = newGaIntegrations;
    newContext = newGaContext;
  }

  return {
    integrations: newIntegrations,
    context: newContext
  };
}
//# sourceMappingURL=processIntegrations.js.map